import { Text } from '@components/primitives/Text'
import type { DrugInteraction } from '@modules/drugs/helpers/getTreatmentPageData'

export const DrugInteractionTemplateString = ({
  drugInteractions,
  drugName,
}: {
  drugInteractions: DrugInteraction[]
  drugName: string
}) => {
  if (drugInteractions.length === 0) {
    return null
  }

  const template = `There are ${drugInteractions.length} known major drug interactions with ${drugName}.`

  return (
    <Text className='my-2 text-dark' styleName={'p-small'} value={template} />
  )
}
